import { apiClient } from "../lib/apiClient";
import type { EventAssignment } from "../types";

export async function listStaff(eventId: string): Promise<EventAssignment[]> {
  const { data } = await apiClient.get<{ staff: EventAssignment[] }>(`/events/${eventId}/staff`);
  return data.staff;
}

export async function addStaff(eventId: string, email: string, name?: string, password?: string): Promise<void> {
  await apiClient.post(`/events/${eventId}/staff`, { email, name, password: password || undefined });
}

export async function removeStaff(eventId: string, userId: string): Promise<void> {
  await apiClient.delete(`/events/${eventId}/staff/${userId}`);
}
